"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useIsListItemDivider;

function useIsListItemDivider() {
  return function isDivider(arrLength, index) {
    var l = arrLength - 1;
    return Boolean(l > 0 && index < l);
  };
}